module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-44.96f8e342.png";